import { Button, Flex, Heading } from '@chakra-ui/react'
import type { UpdateFlexGroup } from 'brokertslib/src/dtos'
import { useFlexGroup } from 'BrokerTsLib/src/hooks/useFlexGroup'
import { useNavigate, useParams } from 'react-router-dom'

import { Container } from '@/components/Container'
import { Loading } from '@/components/Loading'
import { Section } from '@/components/Section'
import { FlexGroupForm } from '@/containers/flex-group/FlexGroupForm'
import { PageContent } from '@/containers/PageContent'
import { PageToolbar } from '@/containers/PageToolbar'
import { ArrowLeft } from '@/icons'

export const FlexGroupEditPage = () => {
  const navigate = useNavigate()

  const { flexGroupId: flexGroupIdParam } = useParams()
  const flexGroupId = parseInt(flexGroupIdParam ?? '')

  const { flexGroup, isLoading, updateAsync } = useFlexGroup(flexGroupId)

  const onSubmit = (data: UpdateFlexGroup) =>
    updateAsync(data)
      .then(() => {
        navigate(`/flex-group/${flexGroup?.id}`)
      })

  return (
    <Section>
      <Container>
        <PageContent>
          <PageToolbar
            sx={{ w: '2xl', margin: '0 auto' }}
            leftElements={
              <Flex sx={{ gap: 4, alignItems: 'center' }}>
                <Heading as="h1">Upravit flexibilní skupinu</Heading>
              </Flex>
            }
          />

          {!flexGroup ? (
            <Loading large />
          ) : (
            <FlexGroupForm
              flexGroup={flexGroup}
              onSubmit={onSubmit}
              leftButton={
                <Button
                  variant="ghost"
                  isLoading={isLoading}
                  type="button"
                  onClick={() => navigate('/flex-group/' + flexGroup.id)}
                >
                  <ArrowLeft color="secondary.500" />
                  Zpět
                </Button>
              }
            />
          )}
        </PageContent>
      </Container>
    </Section>
  )
}
